import SidebarTemplate from 'components/templates/SidebarTemplate';
import React from 'react';
import TimeRecalculationForm from 'components/organismos/master/atendanceManagement/TimeRecalculationForm';

const TimeRecalculationPage = () => (
  <SidebarTemplate>
    <TimeRecalculationForm />
  </SidebarTemplate>
);

export default TimeRecalculationPage;
